import { css } from 'lit';

export const styles = css`
  .form-group {
    margin-bottom: 1.5rem;
  }

  .form-group label {
    display: block;
    margin-bottom: 0.5rem;
    color: var(--sl-color-neutral-700);
    font-weight: 500;
    font-size: 0.875rem;
  }

  .form-group sl-input,
  .form-group sl-select,
  .form-group sl-textarea {
    width: 100%;
  }

  .form-row {
    display: flex;
    gap: 1rem;
  }

  .form-row .form-group {
    flex: 1;
  }

  .form-actions {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 2rem;
  }

  sl-checkbox {
    margin-top: 0.5rem;
  }
`;
